export const DataEditorType = Object.freeze({
    TEXT_FIELD: 0,
    TEXT_AREA: 1, 
    BROWSE_MEDIA: 2,
    DROP_DOWN: 3,
    DATE_TIME_FIELD: 4,
    SUGGESTION_BOX: 5
})

export const DataValidationType = Object.freeze({
    DEFAULT: 0,
    URL: 1
})
